import { ChangeDetectionStrategy, Component, computed, input, InputSignal, OnInit, output } from '@angular/core';

import { ComputedStatistic, LabelOptions, SimpleValueData } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-value-chart',
    styleUrl: '../statistics.component.scss',
    templateUrl: './value-chart.component.html',
})
export class ValueChartComponent implements OnInit {
    public readonly computedStatistic = input.required<ComputedStatistic>();
    public readonly hasDescription = computed<boolean>(() => !!this.computedStatistic()?.description);
    public readonly hasValue = computed(() => {
        const x = this.value()?.x as unknown;

        return x !== undefined && x !== null && x !== '';
    });
    public readonly hoverValueInformationsColor = computed<string>(
        () => this.computedStatistic()?.renderOptions?.colors?.[0] ?? '#2f2f2f',
    );
    public readonly isDashboardFieldInterventionScreen: InputSignal<boolean> = input<boolean>(false);
    public readonly isExpanded: InputSignal<boolean> = input.required<boolean>();
    public readonly isHoverContent = computed<boolean>(() => this.isDashboardFieldInterventionScreen());
    public readonly isPercent = computed<string>(() =>
        this.computedStatistic()?.renderOptions?.labels?.type === LabelOptions.TypeEnum.PERCENTAGE ? '%' : '',
    );
    public readonly isStatisticScreen = input<boolean>(true);
    public readonly pbNoDesc10 = computed<boolean>(
        () => !this.hasDescription() && this.isStatisticScreen() && this.isExpanded(),
    );
    public readonly pbNoDesc7 = computed<boolean>(
        () => !this.hasDescription() && this.isStatisticScreen() && !this.isExpanded(),
    );
    public readonly pbValue20 = computed<boolean>(
        () => this.hasValue() && this.isStatisticScreen() && !this.isExpanded(),
    );
    public readonly pbValue7 = computed<boolean>(
        () => this.hasValue() && this.isStatisticScreen() && this.isExpanded(),
    );
    public ready = output<void>();
    public readonly useMinH64 = computed<boolean>(() => this.isStatisticScreen() && this.isExpanded());
    public readonly useMinH72 = computed<boolean>(() => this.isStatisticScreen() && !this.isExpanded());
    public readonly value = computed<SimpleValueData>(
        () => (this.computedStatistic()?.result?.data ?? {}) as SimpleValueData,
    );

    public ngOnInit(): void {
        this.ready.emit();
    }
}
